export default __webpack_public_path__ + "static/media/dr-amadi.5caef213.png";